import { useEffect, useState } from 'react';
import { Admin } from './Admin.jsx';
import { Site } from './Site.jsx';
import { fetchContent } from './api.js';

export function App() {
  const [content, setContent] = useState(null);
  const [error, setError] = useState('');
  const isAdmin = window.location.pathname.startsWith('/admin');

  useEffect(() => {
    fetchContent()
      .then(setContent)
      .catch((requestError) => setError(requestError.message));
  }, []);

  if (error) {
    return (
      <main className="state-screen">
        <div>
          <p className="eyebrow">Ошибка</p>
          <h1>Не удалось загрузить сайт</h1>
          <p>{error}</p>
        </div>
      </main>
    );
  }

  if (!content) {
    return (
      <main className="state-screen">
        <div className="loader" aria-label="Загрузка" />
      </main>
    );
  }

  if (isAdmin) {
    return <Admin initialContent={content} onContentChange={setContent} />;
  }

  return <Site content={content} />;
}

